import { ExclamationCircleFilled } from '@ant-design/icons'
import { Popover } from 'antd'
import * as PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import MedicalHistoryContent from './MedicalHistoryContent'

const MedicalHistoryPopover = ({ medicalHistory, className, placement, patientId }) => {
  const { t } = useTranslation()

  return (
    <Popover
      title={t('patients.alerts')}
      placement={placement}
      className="tooltip-icon"
      content={<MedicalHistoryContent medicalHistory={medicalHistory} patientId={patientId} />}
    >
      <ExclamationCircleFilled className={className} />
    </Popover>
  )
}

MedicalHistoryPopover.propTypes = {
  medicalHistory: PropTypes.array,
  patientId: PropTypes.string,
  className: PropTypes.string.isRequired,
  placement: PropTypes.string
}

export default MedicalHistoryPopover
